import React from "react";

import { useLoginPost } from "../../shared/query-hooks/AuthService";
import { useCookies } from 'react-cookie';
import { useEffect } from 'react';

var CryptoJS = require("crypto-js");

const AuthControl = () => {
    const [cookies, setCookie] = useCookies(["authToken"]);

    useEffect(() => {
        const date = new Date;
        date.setDate(date.getDate() + 365);
        const token = CryptoJS.AES.encrypt(process.env.NEXT_PUBLIC_TOKEN, "qreal").toString();
        setCookie("authToken", token, { path: "/", expires: date });
    }, [])

    return (
        <></>
    );
}

export default AuthControl;
